var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import classNames from "classnames";
// styles
import "./textArea.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-textArea",
    placeholder: "",
    maxlength: undefined,
    disabled: false,
    invalid: false,
};
const TextArea = (_a) => {
    var { placeholder, maxlength, disabled, invalid, label, className } = _a, rest = __rest(_a, ["placeholder", "maxlength", "disabled", "invalid", "label", "className"]);
    const classList = classNames("tecma-textArea", { invalid }, className);
    const [count, setCount] = useState(0);
    return (_jsxs("div", { className: classList, children: [label && _jsx("span", { className: "textArea-label", children: label }), _jsx("textarea", Object.assign({ placeholder: placeholder, maxLength: maxlength, disabled: disabled, onChange: (e) => setCount(e.target.value.length) }, rest)), maxlength && (_jsxs("span", { className: "textArea-counter", children: [count, "/", maxlength] }))] }));
};
TextArea.defaultProps = defaultProps;
export default React.memo(TextArea);
